import statisticsReport from './view/statisticsReport.html'

export default {
    base: {
        state: 'declaration.declareASummary.statisticsReport',
        config: {
            url: '/statisticsReport',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.declareASummary.statisticsReport.list',
            title: '申报汇总统计',
        },
    },
    list: {
        state: 'declaration.declareASummary.statisticsReport.list',
        config: {
            url: '/list',
            template: statisticsReport,
            controller: 'statisticsReportCtrl',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/statisticsReport/routers.js